import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Camera, Brain, Clock, Handshake } from 'lucide-react';
const benefits = [{
  icon: <MapPin size={32} className="text-white" data-id="element-14" />,
  color: 'bg-terracota',
  title: 'Te encuentran cuando buscan',
  text: 'No importa si es alguien de acá, un turista o alguien que te recomendaron. Cuando buscan, aparecés vos.'
}, {
  icon: <Camera size={32} className="text-white" data-id="element-15" />,
  color: 'bg-ambar',
  title: 'Tu marca se ve como lo que es',
  text: 'Lo que ven online refleja el esfuerzo que pusiste en el negocio real. Sin que vos tengas que pensar en eso.'
}, {
  icon: <Brain size={32} className="text-white" data-id="element-16" />,
  color: 'bg-terracota',
  title: 'Entendés cada decisión',
  text: 'Sabés qué hacemos, cuándo y por qué. Sin tecnicismos, sin sorpresas.'
}, {
  icon: <Clock size={32} className="text-white" data-id="element-17" />,
  color: 'bg-ambar',
  title: 'Vos seguís en tu negocio',
  text: 'La presencia digital trabaja por vos mientras vos atendés lo tuyo.'
}, {
  icon: <Handshake size={32} className="text-white" data-id="element-18" />,
  color: 'bg-terracota',
  title: 'Tenés alguien de confianza',
  text: 'Alguien de acá, que conoce el contexto y está cuando lo necesitás.'
}];
export function Benefits() {
  return <section className="py-20 md:py-32 bg-arena px-5 md:px-8" data-id="element-19">
      <div className="max-w-[900px] mx-auto" data-id="element-20">
        <div className="text-center mb-20" data-id="element-21">
          <motion.span initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-terracota font-nunito text-sm uppercase tracking-[0.1em] font-bold block mb-4" data-id="element-22">
            El resultado
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-3xl md:text-4xl lg:text-5xl font-playfair font-bold text-negro max-w-[700px] mx-auto leading-tight" data-id="element-23">
            Lo que cambia cuando tu marca está bien trabajada.
          </motion.h2>
        </div>

        <div className="space-y-12 md:space-y-0" data-id="element-24">
          {benefits.map((benefit, index) => {
          const isReversed = index % 2 !== 0;
          return <Fragment key={index} data-id="element-25">
                <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.1
            }} className={`flex flex-col md:flex-row items-center gap-6 md:gap-12 py-8 ${isReversed ? 'md:flex-row-reverse text-center md:text-right' : 'text-center md:text-left'}`} data-id="element-26">
                  <div className={`w-[80px] h-[80px] rounded-full flex-shrink-0 flex items-center justify-center shadow-md ${benefit.color}`} data-id="element-27">
                    {benefit.icon}
                  </div>
                  <div className="flex-1" data-id="element-28">
                    <h3 className="text-2xl md:text-3xl font-playfair font-bold text-negro mb-3" data-id="element-29">
                      {benefit.title}
                    </h3>
                    <p className="text-negro/65 font-nunito text-lg leading-relaxed" data-id="element-30">
                      {benefit.text}
                    </p>
                  </div>
                </motion.div>
                {index < benefits.length - 1 && <div className="hidden md:block h-[1px] w-full bg-terracota/15" data-id="element-31"></div>}
              </Fragment>;
        })}
        </div>
      </div>
    </section>;
}